export const main_routes = [
    {
        // path: '/:lang([a-z]{2})',
        path: '/',
        name: 'index',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "" } },
        // props: { data: { page: "Agenda", data: {depId: 1} } },
        meta: { requireAuth: true },
        // children: []
    },
    {
        path: '/login',
        name: "login",
        component: () => import('@/layouts/Login'),
        props: { data: {} },
    },
    {
        path: '/role',
        name: 'roles',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/role/Role" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/user',
        name: 'users',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/user/Users" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/profile/Profile" } },
        meta: { requireAuth: true, requireAdmin: false },
    },

    // {
    //     path: '/dashboard',
    //     name: 'dashboard',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "system_modules/dashboard/Dashboard" } },
    //     meta: { requireNone: true, requireAuth: true, requireAdmin: false },
    // },
    // {
    //     path: '/dashboard2',
    //     name: 'dashboard2',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "system_modules/dashboard/Dashboard2" } },
    //     meta: { requireNone: true, requireAuth: false, requireAdmin: false },
    // },

    {
        path: '/language',
        name: 'lang',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/settings/Language" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    // {
    //     path: '/languages',
    //     name: 'langs',
    //     component: () => import('@/layouts/Main'),
    //     props: { data: { page: "system_modules/settings/LanguageMulti" } },
    //     meta: { requireAuth: true, requireAdmin: false },
    // },
    {
        path: '/system',
        name: 'settings',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/settings/System" } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/layouts/Main'),
        props: { data: { page: "system_modules/settings/About" } },
        meta: { requireAuth: true, requireAdmin: false },
    },

    {
        path: '/pdf/:view/:id/:url',
        name: 'pdf_viewer_letter',
        component: () => import('@/layouts/Empty'),
        props: { data: { page: `views/PDFViewer` } },
        meta: { requireAuth: true, requireAdmin: false },
    },
    // {
    //     path: '/pdf/:view/:url',
    //     name: 'pdf_viewer',
    //     component: () => import('@/layouts/Empty'),
    //     props: { data: { page: `views/PDFViewer` } },
    //     // meta: { requireAuth: true, requireAdmin: true },
    // },

    {
        path: '/notfoundf',
        name: 'notfound_full',
        component: () => import('@/layouts/404'),
        props: { data: { page: "system_modules/NotFound" } },
    },
    {
        path: '/notfound',
        name: 'notfound',
        component: () => import('@/layouts/404'),
        props: { data: { page: "system_modules/NotFound" } },
    },
    {
        path: '/notperm',
        name: 'notperm',
        component: () => import('@/layouts/Empty'),
        props: { data: { page: "system_modules/NotPermission" } },
    },
    {
        path: '/:catchAll(.*)',
        name: '404',
        component: () => import('@/layouts/404'),
        props: { data: { page: "system_modules/NotFound" } },
    },
]
